export const USER_SET = 'USER_SET';
export const USERS_SET_TOKEN = 'USERS_SET_TOKEN';
export const USERS_SET_LOGGED_IN = 'USERS_SET_LOGGED_IN';
export const USER_SET_INITIAL_LOAD_FINISHED = 'USER_SET_INITIAL_LOAD_FINISHED';

// initial state
const state = {
  user: { organization_id: '' },
  tokens: {
    access_token: false
  },
  isLoggedIn: localStorage.getItem('isLoggedIn') === 'true',
  initialLoadFinished: localStorage.getItem('isLoggedIn') !== 'true',
  masquerading: {
    status: false,
    name: '',
  }
}

// getters
const getters = {
  user: state => state.user,
  tokens: state => state.tokens,
  isLoggedIn: (state) => state.isLoggedIn,
  initialLoadFinished: state => state.initialLoadFinished
}

// actions
const actions = {
  getMe({ commit }) {
    return axios.get('/api/user').then((response) => {
      commit(USERS_SET_LOGGED_IN, true)
      commit(USER_SET, { user: response.data.user })

      if (response.data.masquerading) {
        commit('MASQUERADING_SET', response.data.masquerading);
      }
    }).catch(() => {
      commit(USERS_SET_LOGGED_IN, false)
      commit(USER_SET, null)
    }).finally(() => {
      commit(USER_SET_INITIAL_LOAD_FINISHED, true)
    })
  },

  setUser: ({ commit, state }, payload) => {
    commit(USER_SET, {
      user: payload.user
    });
  },

  logoutUser: ({ commit }) => {
    localStorage.setItem('isLoggedIn', 'false');
    commit(USERS_SET_LOGGED_IN, false);
    commit(USER_SET, { user: {} });
  },

  setTokens: ({ commit, state }, tokens) => {
    commit(USERS_SET_TOKEN, {
      tokens: tokens
    });
  }
}

// mutations
const mutations = {
  USER_SET: (state, payload) => {
    if (payload && payload.user) {
      state.user = payload.user;
      document.getElementById('user-id').innerText = payload.user.id;
    } else {
      state.user = null;
      document.getElementById('user-id').innerText = '';
    }
  },

  MASQUERADING_SET(state, { status, name }) {
    state.masquerading.status = status;
    state.masquerading.name = name;
  },

  USERS_SET_LOGGED_IN: (state, payload) => {
    state.isLoggedIn = payload
  },

  USERS_SET_TOKEN: (state, payload) => {
    state.tokens = payload.tokens;
    window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + payload.tokens.access_token;
  },
  USER_SET_INITIAL_LOAD_FINISHED: (state, payload) => {
    state.initialLoadFinished = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
